export default __webpack_public_path__ + "static/media/platformDeviceIcon3.eadb2188.webp";